import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {reExportedColors, FilterButton} from '../../1elements'
import React, {useEffect, useState} from 'react'

const TablePaginationWrapper = ({header, postsPerPage, currentPage, setCurrentPage, totalPosts, columns, setColumns, children}) => {
    const [pageNumbers, setPageNumbers] = useState([])

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    useEffect(()=>{
        const pageNumbersCopy = []
        for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
            pageNumbersCopy.push(i)
        }
        setPageNumbers(pageNumbersCopy)
    }, [totalPosts, postsPerPage])

    return (
        <>
            <Box sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                marginBottom: '8px',
                marginTop: '15px'
            }}>
                <Typography sx={{
                    color: reExportedColors.TEXT,
                    flexGrow: 2,
                    fontFamily: 'Lato',
                    fontSize: '22px',
                    fontWeight: 'bold'
                }}>
                    {header}
                </Typography>
                {
                    totalPosts > 0 && (
                        <Box component='span' sx={{
                            color: reExportedColors.TEXT,
                            fontFamily: 'Roboto, sans-serif',
                            fontSize: '13px',
                            fontWeight: '500',
                            marginRight: '4px'
                        }}>{`${
                            postsPerPage * (currentPage - 1) + 1
                        }-${
                            postsPerPage * currentPage < totalPosts
                                ? postsPerPage * currentPage
                                : totalPosts
                        } of ${totalPosts}`}</Box>
                    )
                }

                <FilterButton columns={columns} setColumns={setColumns} />
            </Box>

            {children}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Box component='nav' sx={{
                    display: 'flex',
                    padding: '4px',
                    width: 'fit-content'
                }}>
                    <Box component='ul' sx={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}>
                        {pageNumbers.map((number) => (
                            <Box component='li' key={number} sx={{
                                cursor: 'pointer',
                                display: 'flex',
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                justifyContent: 'center',
                                marginLeft: '4px',
                                marginRight: '4px',
                                '&:hover': { cursor: 'pointer' }
                            }}>
                                <Box
                                    component='button'
                                    onClick={() => paginate(number)}
                                    sx={number === currentPage
                                        ? {
                                            background: 'none',
                                            border: 'none',
                                            fontWeight: 'bold'
                                        }
                                        : {
                                            background: 'none',
                                            border: 'none',
                                            color: 'black',
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}
                                >
                                    {number}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default TablePaginationWrapper
